<div *ngIf="!hasLookupError" [hidden]=bookingAppointment>
  <div class="modal-header">
    <h4 class="modal-title" *ngIf="!multipleVehicleDescriptions && !creatingNewValuation && !isAlt">Quick Quote</h4>
    <h4 class="modal-title" *ngIf="!multipleVehicleDescriptions && !creatingNewValuation && isAlt">Alt VRM</h4>
    <h4 class="modal-title" *ngIf="isManualLookup">&nbsp;- Manual Lookup</h4>
    <h4 class="modal-title" *ngIf="multipleVehicleDescriptions">Multimatch</h4>
    <h4 class="modal-title" *ngIf="!multipleVehicleDescriptions && creatingNewValuation">Book Valuation</h4>
    <img class="modal-close" (click)="dismissModal()" alt="Dismiss modal">
  </div>
  <div class="modal-body quick-quote-width">
    <div class="container">
      <div class="row">

        <ng-container *ngIf="selectVrm && !hasLookupError">

          <!-- vrm search -->
          <div class="col-12 replace-padding mb-3">
            <app-search-vrm [loading]="isLoading"
                            [displayVrm]="vrm"
                            [altVrm]="isAlt"
                            [isQuickQuote]="true"
                            (vrm)="setVrm($event)"
                            (vehicleDescriptionsResult)="setVehicleDescriptions($event)"
                            (hasLookupError)="setHasLookupError($event)"
                            (isloading)="setIsLoading($event)"
                            (hasMissingVrmRelationship)="setHasMissingVrmRelationship($event)"
                            (allowManualLookup)="manualLookup($event)">
            </app-search-vrm>
          </div>
        </ng-container>

        <ng-container *ngIf="inputDetails">

          <div class="tabstrip">
            <div class="tab" [ngClass]="{'active':currentTab===0}" (click)="tabClick(0)">Vehicle Details</div>
            <div class="tab" [ngClass]="{'active':currentTab===1}" (click)="tabClick(1)">Vehicle Questions</div>
            <div class="tab" [ngClass]="{'active':currentTab===2}" (click)="tabClick(2)">Contact Preferences</div>
          </div>

          <!-- Vehicle Details Tab -->
          <ng-container *ngIf="currentTab===0">
            <div class="col-12 replace-padding">
              <div class="vehicle-image-container">
                <app-vehicle-image
                  [vehicleImage]="vehicleImage"
                  [defaultVehicleImage]="defaultVehicleImageUrl"
                  [selectedGrade]="selectedGrade"
                  [showGrade]="false">
                </app-vehicle-image>
              </div>
              <app-vehicle-details-qq
                [vrm]="vrm"
                [vehicleDescription]="vehicleDescription">
              </app-vehicle-details-qq>
              <div class="quick-quote-btn center">
                <button class="modal-button button_green active" (click)="nextTab(1)">
                  <span class="next-btn-icon"></span>
                  <span class="next-btn-span">Next</span>
                </button>
              </div>    
            </div>
          </ng-container>

          <!-- Vehicle Questions Tab -->
          <ng-container *ngIf="currentTab===1">
            <form [formGroup]="quickQuoteForm" class="replace-padding" (ngSubmit)="nextTab(2)">
              <div class="form-section">
                <div class="multi-control-row">
                  <div class="form-control-qq mileage">
                    <div class="form-label">Enter Vehicle Mileage</div>
                    <input id="mileageInput"
                          type="text"
                          class="form-control input-text mileage"
                          formControlName="mileage"
                          pattern="^[0-9]+([0-9]{0,0})?$"
                          [ngClass]="!this.quickQuoteForm.get('mileage').valid ? 'invalid' : ''"
                          (ngModelChange)="preventInputOnTablet($event)"
                          maxlength="8"
                          mask="separator" thousandSeparator=","
                          required
                          tabindex="-1"
                          autocomplete="off"
                          placeholder="Enter Mileage" />
                    <div class="placeholder">
                      Enter Mileage
                    </div>
                    <span class="placeholder-line"></span>
                  </div>
                  <div>
                    <div class="form-label">Number of Keys</div>
                    <div ngbRadioGroup class="btn-group-toggle option-btn-container keys">
                      <label ngbButtonLabel class="btn option-btn keys" [ngClass]="{'active' : quickQuoteForm.controls.keys.value === 1}">
                        <input class="btn-check" formControlName="keys" type="radio" [value]="1">
                        1
                      </label>
                      <label ngbButtonLabel class="btn option-btn keys" [ngClass]="{'active' : quickQuoteForm.controls.keys.value === 2}">
                        <input class="btn-check" formControlName="keys" type="radio" [value]="2">
                        2
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-section">
                <div class="form-label">Service History</div>
                <div ngbRadioGroup class="btn-group-toggle option-btn-container">
                  <label ngbButtonLabel class="btn option-btn service" *ngFor="let service of serviceHistoryOptions" [ngClass]="{'active' : quickQuoteForm.controls.serviceHistory.value === service.key}">
                    <input class="btn-check" formControlName="serviceHistory" type="radio" [value]="service.key">
                    {{ service.value }}
                  </label>
                </div>
              </div>
              <div class="form-section">
                <div class="form-label">Previous Keepers</div>
                <div ngbRadioGroup class="btn-group-toggle option-btn-container">
                  <label ngbButtonLabel class="btn option-btn keeper" *ngFor="let keeper of keeperOptions" [ngClass]="{'active' : quickQuoteForm.controls.keepers.value === keeper.key}">
                    <input class="btn-check" formControlName="keepers" type="radio" [value]="keeper.key">
                    {{ keeper.value }}
                  </label>
                </div>
              </div>
              <div class="form-section">
                <div class="form-label">Please Select Grade of the Vehicle</div>
                <div ngbRadioGroup class="btn-group-toggle option-btn-container">
                  <label ngbButtonLabel class="btn option-btn grade" *ngFor="let grade of grades" [ngClass]="{'active' : quickQuoteForm.controls.grade.value === grade}">
                    <input class="btn-check" formControlName="grade" type="radio" [value]="grade">
                    {{ grade }}
                  </label>
                </div>
              </div>
              <div class="form-section" [hidden]="!vehicleDescription.Commercial">
                <div class="form-label">Is the customer VAT registered?</div>
                <div ngbRadioGroup class="btn-group-toggle option-btn-container yes-no">
                  <label ngbButtonLabel class="btn option-btn yes-no" [ngClass]="{'active' : quickQuoteForm.controls.isVatRegistered.value === 1}">
                    <input class="btn-check" formControlName="isVatRegistered" type="radio" [value]="1">
                    Yes
                  </label>
                  <label ngbButtonLabel class="btn option-btn yes-no" [ngClass]="{'active' : quickQuoteForm.controls.isVatRegistered.value === 0}">
                    <input class="btn-check" formControlName="isVatRegistered" type="radio" [value]="0">
                    No
                  </label>
                </div>
              </div>
              <div class="quick-quote-btn center">
                <button class="modal-button button_green" type="submit"
                        [ngClass]="{'active':quickQuoteForm.valid, 'invalid':!quickQuoteForm.valid, 'loading': quickQuoteLoading}"
                        [disabled]="!quickQuoteForm.valid">
                  <span class="next-btn-icon" [ngClass]="{ 'invalid': !quickQuoteForm.valid }"></span>
                  <span class="next-btn-span">Next</span>
                </button>
              </div>
            </form>    
          </ng-container>

          <!-- Contact Preferences Tab -->
          <ng-container *ngIf="currentTab===2">
            <form [formGroup]="contactForm" class="replace-padding" (ngSubmit)="getQuickQuote()">
              <div class="form-section">
                <div class="form-control-qq email">
                  <div class="form-label">Enter Customer's Email Address</div>
                  <input id="emailInput"
                        type="text"
                        class="form-control input-text email"
                        formControlName="email"
                        [ngClass]="!this.contactForm.controls.email.valid ? 'invalid' : ''"
                        required
                        tabindex="-1"
                        autocomplete="off"
                        placeholder="Enter Email" />
                  <div class="placeholder">
                    Enter Email
                  </div>
                  <span class="placeholder-line"></span>
                </div>
              </div>
              <div class="form-section">
                <div class="form-control-qq phone">
                  <div class="form-label">Enter Customer's Phone Number</div>
                  <input id="phoneInput"
                        type="text"
                        class="form-control input-text phone"
                        formControlName="phone"
                        [ngClass]="!this.contactForm.controls.phone.valid ? 'invalid' : ''"
                        tabindex="-1"
                        autocomplete="off"
                        placeholder="Enter Number" />
                  <div class="placeholder">
                    Enter Number
                  </div>
                  <span class="placeholder-line"></span>
                </div>
              </div>
              <div class="form-section">
                <div class="d-flex align-items-center">
                  <div class="check-box-extent">
                    <label>
                      <input class="d-none" type="checkbox" formControlName="emailOptIn">
                      <span class="check-box-content"></span>
                    </label>
                  </div>
                  <div class='check-box-label'>
                    By ticking this you consent to receiving communications including updates,
                    price increases and seasonal offers.
                  </div>
                </div>
              </div>
              <div class="quick-quote-btn center">
                <button class="modal-button button_green" type="submit"
                        [ngClass]="{'active':contactForm.valid, 'invalid':!contactForm.valid, 'loading': quickQuoteLoading}"
                        [disabled]="!contactForm.valid">
                  <span class="quick-quote-icon" [ngClass]="{'active':contactForm.valid, 'invalid':!contactForm.valid, 'loading': quickQuoteLoading}"></span>
                  <span class="quick-quote-span">Get a Quick Quote</span>
                </button>
              </div>
            </form>
          </ng-container>

        </ng-container>

        <!-- Valuation Result -->
        <ng-container *ngIf="showValuation">        
          <div class="col-12 replace-padding">
            <div class="quote-amount" *ngIf="quickQuoteForm.controls.isVatRegistered.value === 0">{{ vehiclePriceOffered | currency:'GBP':'symbol':'1.0-0'}}</div>
            <div class="quote-amount" *ngIf="quickQuoteForm.controls.isVatRegistered.value === 1">
              <div class="d-inline-block">
                {{ vehiclePriceOffered * 1.2 | currency:'GBP':'symbol':'1.0-0'}}<span class="vat-option"> inc. VAT</span>
                &nbsp;
                {{ vehiclePriceOffered | currency:'GBP':'symbol':'1.0-0'}}<span class="vat-option"> exc. VAT</span>
              </div>
            </div>
            <div class="quote-price-promise-text">
              This is a quick quote based on the buyer’s limited assessment.
            </div>
            <div class="quote-price-promise-text pb-2">
              This price is not guaranteed, the vehicle would need to complete a full valuation.
            </div>
            <app-vehicle-image [vehicleImage]="vehicleImage"
                                [defaultVehicleImage]="defaultVehicleImageUrl"
                                [selectedGrade]="quickQuoteForm.controls.grade.value"
                                [showGrade]="true">
            </app-vehicle-image>
            <div class="salvage-warning" *ngIf="vehicleDescription.HasSalvage">
              The price has been affected by the Vcheck result.
            </div>
            <app-vehicle-details-qq
              [vrm]="vrm"
              [vehicleDescription]="vehicleDescription">
            </app-vehicle-details-qq>
          </div>
          <div class="quick-quote-btn center">
            <button [ngClass]="{'active':quickQuoteForm.valid, 'invalid':!quickQuoteForm.valid, 'loading': bookValuationLoading}" class="modal-button button_green active" type="submit" [disabled]="bookValuationLoading" (click)="bookValuation()">
              <span [ngClass]="{'loading': bookValuationLoading}" class="book-valuation-icon"></span>
              <span class="book-valuation-span">Book Valuation</span>
            </button>
          </div>
        </ng-container>

        <!-- Multimatch -->
        <ng-container *ngIf="multipleVehicleDescriptions">
          <app-registration-plate
            [vrm]="vrm">
          </app-registration-plate>
          <div class="col-12 replace-padding mb-1">
            <app-multiple-derivatives [vehicleDescriptions]="multipleVehicleDescriptions"
                                      [isQuickQuote]="true"
                                      (selectedDerivativeEmitter)="setSelectedDerivative($event)">
            </app-multiple-derivatives>
          </div>
        </ng-container>

        <!-- Book Valuation Questions -->
        <div *ngIf="creatingNewValuation" class="col-12 replace-padding">
          <app-valuation-questions [vrm]="vrm"
                                   [altVrm]="altVrm"
                                   [mileage]="mileage"
                                   [bookId]="bookId"
                                   [isQuickQuote]="true"
                                   [userData]="lookupData"
                                   [quoteId]="vehicleDescription.QuoteId"
                                   [quoteGuid]="vehicleDescription.QuoteGuid"
                                   [vehicle]="this.vehicleDescription"
                                   (bookingAppointment)="setBookingAppointment($event)"
                                   (dismissModal)="dismissModal()">
          </app-valuation-questions>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- vrm error modal -->
<app-lookup-error *ngIf="hasLookupError" [vrm]="vrm" [missingVrmRelationship]="hasMissingVrmRelationship"
 [allowManualLookup]="allowManualLookup" [isStartPurchase]="this.creatingNewValuation" [isQuickQuote]="true" 
 [unableToPurchase]="hasLookupError" [requiresManualValuation]="requiresManualValuation"
  (trySearchAgain)="tryAgain($event)">
</app-lookup-error>
